<template>

  <!-- Section header 1 -->
  <div class="header" 
     :class="{'header1': type === 'h1', 'header2': type === 'h2', 'header3': type === 'h3'}">
    <div class="text">
      <slot>

      </slot>
      
    </div>
    <div class="line">
    
    </div>
    <div class="icon">
      <slot name="icon"></slot>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'tlHeader',
    props: ['type'],
    data(){
      return {

      }
    }
  }
</script>
<style lang="">
  
</style>
